import { useI18n } from "@/context/I18nContext";

const COLORS = {
  new: { bg: "var(--info-bg)", fg: "var(--info)" },
  in_progress: { bg: "var(--warning-bg)", fg: "var(--warning)" },
  quoted: { bg: "#EDE9FE", fg: "#6D28D9" },
  accepted: { bg: "var(--success-bg)", fg: "var(--success)" },
  closed: { bg: "var(--surface-alt)", fg: "var(--text-muted)" },
  rejected: { bg: "var(--danger-bg)", fg: "var(--danger)" },
  pending: { bg: "var(--warning-bg)", fg: "var(--warning)" },
  approved: { bg: "var(--success-bg)", fg: "var(--success)" },
};

export function StatusBadge({ status }) {
  const { t } = useI18n();
  const c = COLORS[status] || { bg: "var(--surface-alt)", fg: "var(--text-muted)" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center text-[10px] font-bold uppercase tracking-[0.16em] px-2.5 py-1 rounded-full border"
      style={{ background: c.bg, color: c.fg, borderColor: `color-mix(in srgb, ${c.fg} 22%, transparent)` }}
    >
      {t(`status.${status}`)}
    </span>
  );
}
